
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>Content Removal Policy</h1>
<hr>
<p>At Anymate, we are committed to maintaining a respectful and safe environment for all users. We understand that certain content may not adhere to our guidelines or may be deemed inappropriate. This Content Removal Policy outlines the procedures and circumstances under which content may be removed from our platform.</p>
<h2>Types of Removable Content:</h2>
<ol>
<li>Content that violates our Community Guidelines.</li>
<li>Content that infringes upon intellectual property rights.</li>
<li>Content that is considered illegal, harmful, or abusive.</li>
<li>Content that involves impersonation or unauthorized use of personal information.</li>
</ol>
<h2>Reporting Mechanism:</h2>
<ol>
<li>Users can report inappropriate content through our reporting system available on each content page.</li>
<li>Reports can also be sent directly to our support team at <a href="mailto:support@any-mate.com">support@any-mate.com</a>.</li>
</ol>
<h2>Review Process:</h2>
<ol>
<li>All reported content is reviewed by our moderation team within 24 hours.</li>
<li>During the review, content may be temporarily removed or restricted until a final decision is made.</li>
</ol>
<h2>Consequences of Violation:</h2>
<ol>
<li>Repeated violations of our Content Removal Policy may result in account suspension or termination.
For any questions or concerns regarding this policy, please contact us at <a href="mailto:support@any-mate.com">support@any-mate.com</a></li>
</ol>
</div>
</template>
